/*
 * Marketing pixel bootstrap: Google Ads and Omnisend sections copied verbatim
 * from the live theme (trippyboys-theme-v10, assets/pixel-loader.js).
 * Stape/GTM and TikTok sections intentionally not copied (owner decision 2026-10-24).
 */

/* Google Ads (gtag.js loads separately as an async <script src> tag) */
window.dataLayer = window.dataLayer || [];
function gtag() { dataLayer.push(arguments); }
gtag("js", new Date());
gtag("config", "AW-17949933519");

/* Omnisend SDK — visitor tracking, cart abandonment & forms */
window.omnisend = window.omnisend || [];
omnisend.push(["brandID", "6a0cab60d38720b69441dc89"]);
omnisend.push(["track", "$pageViewed"]);
